(() => {
(function($) {
    $(document).ready(function() {
        $('map area[id]').hover(function() {
            const estado = $(this).attr('id');
            $('.' + estado).toggleClass('mostra');
            $('.deslocamento-' + estado).toggleClass('jornais-view');
        });
    });
})(jQuery);



})();
//# sourceMappingURL=index.js.map
